import { render, staticRenderFns } from "./CardFlip.vue?vue&type=template&id=1c4eaeca&"
import script from "./CardFlip.vue?vue&type=script&lang=js&"
export * from "./CardFlip.vue?vue&type=script&lang=js&"
import style0 from "./CardFlip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports